/**
 * Given an attribute type, this will create an i18nResolver type name
 * to be used by the models, editors, and i18nResolver factory.
 * This returns 'attr.i18nResolver.${type}'
 */
function getI18nResolverTypeForType(type) {
  return `attr.i18nResolver.${type}`;
}
export default {
  getI18nResolverTypeForType
};